module.exports = __webpack_public_path__ + "img/mixpanel.3e5e0c50.svg";